import React, { useState } from 'react';
import { updateAdminConfig } from '../../utils/api';

const AdminDistribution = ({ config, loadConfig, flash }) => {
  const [dist, setDist] = useState({ ...(config.adminDistribution || {}) });
  const total = (dist.itFund||0) + (dist.marketingFund||0) + (dist.legalFund||0) + (dist.awardFund||0);

  return (
    <div className="fade-in">
      <h2 className="adm-title">Admin Token Distribution</h2>
      <p className="adm-hint">How {config.adminPercent}% admin tokens split. Must total 100%.</p>
      <div className="adm-alloc-grid">
        {[['itFund','IT Fund'],['marketingFund','Marketing'],['legalFund','Legal'],['awardFund','Award']].map(([k,l])=>(
          <div key={k} className="card adm-alloc-card">
            <div className="adm-alloc-hdr"><span>{l}</span><div className="adm-alloc-input"><input type="number" value={dist[k]??''} onChange={e=>setDist({...dist,[k]:parseFloat(e.target.value)||0})} className="input input-sm adm-alloc-num"/><span className="text-3">%</span></div></div>
          </div>
        ))}
      </div>
      <div className="adm-alloc-footer">
        <span className={`adm-alloc-total mono ${total===100?'text-green':'text-red'}`}>Total: {total}%</span>
        <button className="btn btn-primary" onClick={async()=>{if(total!==100){flash(`Must be 100%. Got ${total}%`,'error');return;}try{await updateAdminConfig({adminDistribution:dist});flash('Saved');loadConfig();}catch(e){flash(e.response?.data?.error||'Failed','error');}}}>Save</button>
      </div>
    </div>
  );
};

export default AdminDistribution;